// Operator selection: display metadata + which operators are in play, persisted
// across reloads via first-party localStorage (no third-party JS).
import type { Op } from "./problem";

/** Display order on the toggle bars. */
export const OP_ORDER: readonly Op[] = ["+", "-", "*", "/"];

/** Proper math glyphs for display (the equation/buttons), keyed by the ASCII Op. */
export const OP_GLYPH: Record<Op, string> = { "+": "+", "-": "−", "*": "×", "/": "÷" };

/** First-ever-load default; thereafter the saved selection wins. */
export const DEFAULT_OPS: readonly Op[] = ["+", "-"];

const STORE_KEY = "gms.ops";

export function loadOps(): Set<Op> {
  try {
    const raw = localStorage.getItem(STORE_KEY);
    if (raw) {
      const arr = (JSON.parse(raw) as unknown[]).filter(
        (o): o is Op => typeof o === "string" && (OP_ORDER as readonly string[]).includes(o),
      );
      if (arr.length) return new Set(arr);
    }
  } catch {
    /* storage unavailable / malformed — fall through to defaults */
  }
  return new Set(DEFAULT_OPS);
}

export function saveOps(ops: Set<Op>): void {
  try {
    localStorage.setItem(STORE_KEY, JSON.stringify([...ops]));
  } catch {
    /* persistence is best-effort */
  }
}
